module.exports = __webpack_public_path__ + "img/discount50percent.17417f25.png";